import { render, staticRenderFns } from "./rule.vue?vue&type=template&id=5397295f&scoped=true&"
import script from "./rule.vue?vue&type=script&lang=ts&"
export * from "./rule.vue?vue&type=script&lang=ts&"
import style0 from "./rule.vue?vue&type=style&index=0&id=5397295f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5397295f",
  null
  
)

export default component.exports